export enum UserLicenseTypeEnum {
    Expired = 1,
    Paid = 2,
    Eval = 3,
    Unassigned = 4
}